import { jsx as y } from "react/jsx-runtime";
import "react";
import { classNames as h } from "../../utilities/index.js";
const f = ({ href: t, type: p = "button", color: e = "primary", size: a = "lg", wide: l = !1, variant: n = "sharp", component: i, className: r, children: s, passTo: d = !1, ...u }) => {
  const b = h({
    "sash-Button [&:has(span:nth-child(2))>span:first-child]:mr-2 text-sm inline-flex items-center justify-center w-full font-semibold uppercase tracking-[1.25px] text-center cursor-pointer disabled:pointer-events-none focus-visible:underline": !0,
    "no-underline": e !== "tertiary" && e !== "tertiary-alt",
    "border leading-tight no-underline": !(e != null && e.includes("tertiary")),
    "sash-Button--primary bg-primary text-black border-black hover:bg-primary/70 disabled:bg-gray-10 disabled:border-gray-10 disabled:text-gray-60": e === "primary",
    "sash-Button--primaryAlt bg-black text-white border-black hover:bg-black/70 disabled:opacity-50": e === "primary-alt",
    "sash-Button--secondary bg-transparent text-black border-black hover:opacity-70 disabled:opacity-50": e === "secondary",
    "sash-Button--secondaryAlt bg-transparent text-white border-white hover:opacity-70 disabled:opacity-50": e === "secondary-alt",
    "sash-Button--tertiary py-1 text-black hover:opacity-70 leading-relaxed disabled:opacity-50": e == null ? void 0 : e.includes("tertiary"),
    "underline hover:no-underline decoration-2 underline-offset-4 decoration-primary": e === "tertiary",
    "underline hover:no-underline decoration-2 underline-offset-4 decoration-black": e === "tertiary-alt",
    "p-3 xl:p-4": a !== "sm" && !(e != null && e.includes("tertiary")),
    "p-3": a === "sm" && !(e != null && e.includes("tertiary")),
    rounded: n === "rounded" && !(e != null && e.includes("tertiary")),
    "rounded-full": n === "pill" && !(e != null && e.includes("tertiary")),
    "sm:w-auto": !l,
    [r]: r
  }), m = i || "a";
  return t ? /* @__PURE__ */ y(
    m,
    {
      to: d ? t : null,
      href: d ? null : t,
      className: b,
      ...u,
      children: s
    }
  ) : /* @__PURE__ */ y(
    "button",
    {
      type: p,
      className: b,
      ...u,
      children: s
    }
  );
}, v = f;
export {
  v as default
};
